export default {
    videos: 'Videos',
    data_consumed: 'Dades consumides (mb)',
    size: 'Grandària (Mb)',
    lms_link: 'LMS Link',
    video: 'Video',
    no_file: 'No hi ha cap fitxer',
    text_upload_file: 'Começar a carregar un nou fitxer',
    upload: 'Carrega',
}